export default __webpack_public_path__ + "static/media/vertical_top_to_bottom_right.c2a592ee.PNG";